import SVG from "../SVG"
import ButtonLoader from "../AsyncState/ButtonLoader";
import { Tooltip } from "react-tooltip";
export default function TableButton({text="", svg_name="", svgClassName="", href="", className="", textShadow="", svgShadow="", tooltip=false, tooltipText="", onClick, loading=false, disabled=false, loadingLabel="در حال انجام" }) {
  return (
    <div className="w-full flex items-center justify-center">
      <a
        href={href || "#"}
        onClick={(e) => {
          if (disabled || loading) { e.preventDefault(); return; }
          if (onClick) {
            e.preventDefault()
            onClick(e)
          }
        }}
        data-tooltip-id={tooltip ? `${svg_name}Tooltip` : undefined}
        data-tooltip-content={tooltip ? tooltipText : undefined}
        aria-disabled={disabled || loading}
        aria-busy={loading}
        className={`rounded-xl flex items-center justify-center gap-2.5 py-3 outline-none text-sm ${(disabled || loading) ? "pointer-events-none opacity-60" : ""} ${className}`}
      >
        {loading ? <ButtonLoader label={loadingLabel} /> : <><SVG name={svg_name} classname={`${svgClassName} ${svgShadow ? "drop-shadow-md" : ""}`}/>{textShadow ? <span className="drop-shadow-md">{text}</span> : <span>{text}</span>}</>}
      </a>
      {tooltip && (
        <Tooltip
          id={`${svg_name}Tooltip`}
          place="bottom"
          className="z-50 !py-1 !px-2 !text-xs !font-thin !backdrop-blur !bg-zi-blue-dark !rounded-lg"
        />
      )}
    </div>
  )
}
